import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";

import help from "../assets/help.png";
import calendar from "../assets/calendar.ico";

// import ReactTooltip from "react-tooltip";

import {
  faAngleDown,
  faStopCircle,
  faCircle,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { Icon, Menu, Popup } from "semantic-ui-react";
import colors from "../../colors";
import { NoEncryption } from "@material-ui/icons";
// import {Link} from "react-router-dom";

library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
library.add(faDownload);

export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      selected: false,
      color: props.color,
      prevColor: props.color,
    };
  }
  onClick_meta = () => {
    this.props.updateMetaData();
  };
  onClick_print = () => {
    this.props.PrintOption();
  };

  onClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      color: !this.state.collapsed
        ? colors["sidebar-sub-menu"]
        : this.state.prevColor,
    });
  };

  onClickChild = () => {
    // this.setState({selected:!this.state.selected})

    if (
      this.props.data.ismap &&
      this.props.selectedMenu !== this.props.data.name
    ) {
      this.props.toggleSelectedNodeStatus(this.props.data.name);
      this.props.setSelectedMenu(this.props.data.name);
      this.props.setSelectedLayer(this.props.data.name);
    }
  };

  componentDidMount() {
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
  }
  openText = () => {
    this.props.EBPToggle(this.props.data.name);
  };

  render() {
    let subtree = null;
    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        return (
          <TreeNode
            key={key}
            data={child}
            EBPToggle={this.props.EBPToggle}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            color={this.state.color}
            date={this.props.date}
            availableDates={this.props.availableDates}
            handleDateChange={this.props.handleDateChange}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStatus={this.props.selectedNodeStatus}
            selectedMenu={this.props.selectedMenu}
            updateMetaData={this.props.updateMetaData}
            PrintOption={this.PrintOption}
            modeChange={this.props.modeChange}
            inlinemode={this.props.inlinemode}
          />
        );
      });
    }

    if (subtree) {
      return <div className="modalbox"></div>;
    } else {
      // console.log(lenSelected)
      // let path=lenSelected>0?`/${this.props.selected[lenSelected-1].toLowerCase().split(' ').join('-')}`:"/"
      // console.log(path)
      return (
        <div
          class="grid-container"
          style={{
            background: colors["final_side"],
            display: "none"
          }}
        >
          <div
            class="grid-child"
            style={{
              background: colors["final_side"],
              width: "210px",
              padding: "1px",
              display: "none"
            }}
          >
            {/* <Menu.Item
              as="a"
              data-id={this.props.data.id}
              onClick={this.onClickChild}
              style={{ textAlign: "left", color: colors["black"] }}
            >
              <span style={{ padding: "1px" }}>
                {this.props.selectedNodeStatus[this.props.data.name] ? (
                  <FontAwesomeIcon icon="stop-circle" />
                ) : (
                  <FontAwesomeIcon icon="circle" />
                )}
              </span>

              {this.props.data.displayname}
            </Menu.Item> */}
          </div>

          <div
            class="grid-child"
            style={{
              background: colors["final_side"],
              textAlign: "right",
              margin: "auto",
              color: "black",
            }}
          >
            <div class="row">
              <div class="column">
                <img
                  src={help}
                  width="20"
                  height="20"
                  align="right"
                  onClick={this.openText}
                  alt="help"
                ></img>
              </div>

              {/* <div class="column">
                {this.props.selectedNodeStatus[this.props.data.name] ? (
                  <Popup
                    position="top right"
                    onOpen={
                      this.props.modeChange
                     }
                     open={this.props.inlinemode}
                    trigger={
                      <img
                        src={calendar}
                        width="20"
                        height="20"
                        align="right"
                        alt="calendar"
                      ></img>
                    }
                    on="click"
                  > {this.props.inlinemode?
                    <DateInput
                      // inline
                      name="date"
                      inline={true}
                      value={moment(this.props.date, "DD-MM-YYYY").format(
                        "DD-MM-YYYY"
                      )}
                      onChange={this.props.handleDateChange}
                      dateFormat="DD-MM-YYYY"
                      markColor="orange"
                      placeholder="Date"
                      iconPosition="left"
                      closable
                      initialDate={this.props.date}
                      enable={this.props.availableDates}
                      marked={this.props.availableDates}
                      startMode="day"
                      pickerWidth="200px"
                      popupPosition="top right"
                      clearIcon={<Icon name="remove" color="red" />}
                    />:null}
                  </Popup>
                ) : null}
              </div> */}


            </div>
          </div>
        </div>
      );
    }
  }
}
